<template>
  <div>

    <div style="display: inline-block; position:relative;">

      <v-avatar :size="avatarSize">
        <fin-profile-img dark v-if="loadToPreventRefreshError"/>
        <croppa
          :disable-click-to-choose="true"
          :disable-drag-and-drop="false"
          :disable-drag-to-move="viewMode"
          :disable-pinch-to-zoom="viewMode"
          :disable-rotation="viewMode"
          :disable-scroll-to-zoom="viewMode"
          :initial-image="image"
          :prevent-white-space="true"
          :show-remove-button="false"
          @new-image="viewMode=false"
          imageBorderRadius="50%"
          v-if="image"
          v-model="croppa"
          v-show="!loadToPreventRefreshError"
        >
          <img :src="require('@/assets/profile/anonymous-avatar.png')" crossorigin="anonymous" slot="placeholder">
        </croppa>
      </v-avatar>

      <v-btn
        @click="()=> {this.loadToPreventRefreshError = false; croppa.chooseFile()}"
        color="fin-color-primary-dark"
        dark
        fab
        small
        v-style:left="$valueByBreakpoint({xs: avatarSize - 20 + 'px', sm: avatarSize - 30 + 'px', md: avatarSize - 25 + 'px', lg: avatarSize - 35+ 'px', xl: avatarSize - 35+ 'px'})"
        style="position: absolute; bottom: 0; border-radius: 50% !important; z-index: 1;"
        v-if="viewMode"
        :disabled="disabled"
      >
        <v-icon>icon-edit</v-icon>
      </v-btn>

      <v-btn
        :loading="loading"
        @click="uploadAvatar"
        color="fin-color-accent-green"
        dark
        fab
        small
        style="position: absolute; bottom: 0; right:15px; border-radius: 50% !important;"
        v-if="!viewMode"
      >
        <v-icon>icon-check</v-icon>
      </v-btn>

      <v-btn
        @click="croppa.zoomOut()"
        color="fin-color-primary-dark"
        dark
        fab
        small
        style="position: absolute; top: 35px; right:-5px; border-radius: 50% !important;"
        v-if="!viewMode"
      >
        <v-icon>mdi-magnify-minus</v-icon>
      </v-btn>

      <v-btn
        @click="croppa.zoomIn()"
        color="fin-color-primary-dark"
        dark
        fab
        small
        style="position: absolute; top: 0; right:15px; border-radius: 50% !important;"
        v-if="!viewMode"
      >
        <v-icon>mdi-magnify-plus</v-icon>
      </v-btn>

    </div>
  </div>
</template>

<script>
import FinProfileImg from '@/components/pages/profile/ProfileImg'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'fin-profile-image-editor',
  components: {FinProfileImg},
  props: {
    avatarSize: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      loadToPreventRefreshError: true,
      croppa: {},
      loading: true,
      viewMode: true,
      disabled: process.env.VUE_APP_ALLOW_CHANGE_PROFILE !== 'true',
    }
  },
  asyncComputed: mapState('auth', {
    async image(state) {
      this.loading = true
      if (!state.profile.image || this.loadingError) {
        this.loading = false
        return require('@/assets/profile/anonymous-avatar.png')
      }
      try {
        const result = this.$Amplify.Storage
          .get(state.profile.image, { level: 'protected' })
        this.loading = false
        return result
      } catch (e) {
        this.loading = false
        return require('@/assets/profile/anonymous-avatar.png')
      }
    }
  }),
  methods: {
    ...mapActions('auth', ['updateProfileImage']),
    uploadAvatar () {
      const format = 'image/png'
      this.loading = true
      this.croppa.generateBlob(blob => {
        this.updateProfileImage(blob).then(result => {
          this.loading = false
          this.viewMode = true
        }).catch(err => {
          this.loading = false
          console.error('error loading avatar', err)
        })
      }, format
      )
    },
    setError (e) {
      this.loading = false
      console.error('ProfileImageEditor TODO track and log', e)
    }
  }
}
</script>

<style scoped>

</style>
